import { ActionContextBasic } from '../index'
import { Snack, SnackType } from '@/interfaces/snack'

export interface State {
  snacks: Snack[]
}

const state = () => ({
  snacks: []
})

const mutations = {
  INSERT_MSG (state: State, msg: Snack) {
    state.snacks.push(msg)
  },
  REMOVE_MSG (state: State, resIndex: number) {
    let leftSnacks = state.snacks.concat()
    leftSnacks.splice(resIndex, 1)
    state.snacks = leftSnacks
  }
}

const actions = {
  showSnack: (context: ActionContextBasic, msg: Snack) => {
    let duration = 2000
    switch (msg.type) {
      case SnackType.Error:
        duration = 2000
        break
      case SnackType.Success:
      default:
        duration = 1000
        break
    }
    context.commit('INSERT_MSG', msg)
    setTimeout(() => {
      context.commit('REMOVE_MSG', 0)
    }, duration)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
